module.exports = __webpack_public_path__ + "static/media/heattread-5.13412778.jpg";